import React, { useContext, useEffect, useMemo, useState } from "react";
import { Link, useNavigate } from 'react-router-dom';
import { Box, Grid, } from "@mui/material";
import { useTranslation } from "react-i18next";
import DataTable from "../../components/common/DataTable";
import { AuthContext } from "../../context/AuthContext";
import { genericGet } from "../../services/apiServices";
import { GET_RECEIPT_REGISTER } from "../../services/apiRoutes";
import CustomReport from "../common/CustomReport";
import { useCompanyDateFormat } from "../../constants/useCompanyDateFormat";
import CustomFilter from "../common/CustomFilter";
import CustomTextField from "../common/CustomTextField";
import CustomAutocomplete from "../common/CustomAutoComplete";
import FindReplaceOutlinedIcon from '@mui/icons-material/FindReplaceOutlined';
import { ClearRounded, } from "@mui/icons-material";
import { genericPost } from "../../services/authServices";
import CustomDataTable from "../common/CustomDataTable";
import CustomButton from "../common/CustomButton";
import { getCustumersList } from "../../services/CommonServices";
import { AccessDenied, hasCreatePermission, hasDeletePermission, hasEditPermission, hasViewPermission } from "../../services/CommonServices";
import { useLocation } from "react-router-dom";


const title = "Receipt Register";

const Function = () => {
    const { t, i18n } = useTranslation();
    const companyDateFormat = useCompanyDateFormat();
    const navigate = useNavigate();
    const [permission, setPermissions] = useState()
    const [data, setData] = useState([]);
    const { token } = useContext(AuthContext)
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const filterOpen = () => setOpenDrawer(true);
    const filterClose = () => setOpenDrawer(false);
    const [openDrawer, setOpenDrawer] = useState(false);
    const [custumersList, setCustumersList] = useState([]);
    // ✅ Pagination states
    const [page, setPage] = useState(0); // UI 0-based
    const [pageSize, setPageSize] = useState(10);
    const [rowCount, setRowCount] = useState(0);

    const [filterPayload, setFilterPayload] = useState({
        shipmentId: '',
        customerName: '',
        fromDate: '',
        toDate: '',

    });
    const location = useLocation();
    const currentPath = location.pathname;
    useEffect(() => {
        let rolePermisionsData = JSON.parse(sessionStorage.getItem('userData')) || []
        let editPermision = hasEditPermission(currentPath, rolePermisionsData?.permissions)
        let deletePermission = hasDeletePermission(currentPath, rolePermisionsData?.permissions)
        let createPermision = hasCreatePermission(currentPath, rolePermisionsData?.permissions)
        let viewPermision = hasViewPermission(currentPath, rolePermisionsData?.permissions)

        setPermissions({
            edit: editPermision,
            delete: deletePermission,
            create: createPermision,
            view: viewPermision,
        })
    }, [])

    const handleFilterChange = (field, value) => {
        setFilterPayload((prev) => ({
            ...prev,
            [field]: value || '',
        }));
    };
    const handleClearFilters = useMemo(() => {
        return () => {
            setFilterPayload({
                shipmentId: '',
                customerName: '',
                fromDate: '',
                toDate: '',
            });
            fetchData(0, pageSize, '');
        };
    }, [pageSize]);
    useEffect(() => {
        getCommonData();
    }, []);

    useEffect(() => {
        getCommonData();
    }, []);

    const getCommonData = async () => {
        const custumersList = await getCustumersList();
        setCustumersList(custumersList);
    }

    const columns = useMemo(
        () => [
            { accessorKey: "index", header: "SN.", size: 50, tableHeader: { alignItems: 'center', }, tableStyle: { textAlign: "center" }, enableColumnFilter: false },
            { accessorKey: 'date', header: 'Date', size: 100, tableStyle: { textAlign: "center" }, },
            { accessorKey: 'receiptVoucherNo', header: 'Voucher No.', size: 100, tableStyle: { textAlign: "center" }, },
            { accessorKey: 'shipmentId', header: 'Shipment ID', size: 100, tableStyle: { textAlign: "center" }, },
            {
                accessorKey: 'customerName', header: 'Customer Name', size: 150, tableHeader: {
                    justifyContent: 'flex-start',
                },
            },
            { accessorKey: 'amount', header: 'Amount', size: 50, tableStyle: { textAlign: "center" }, },
        ],
        [permission]
    );
    const fetchData = async (pageIndex = 0, pageSize = 10,) => {
        setLoading(true);
        try {
            // const response = await genericGet({ url: GET_RECEIPT_REGISTER });
            const payload = {
                page: pageIndex + 1,
                limit: pageSize,
                ...filterPayload
            };

            const response = await genericPost(GET_RECEIPT_REGISTER, payload, {});

            if (response.data.success && response.data.receiptVouchers) {
                const receiptData = response.data.receiptVouchers.map((voucher, index) => {
                    const totalReferenceAmount = (voucher.particulars || []).reduce((sum, p) => {
                        return sum + parseFloat(p.referenceAmount || 0);
                    }, 0);

                    const currencySymbol = voucher?.currency?.currency_symbol || '';
                    const formattedAmount = `${currencySymbol} ${totalReferenceAmount.toFixed(2)}`;

                    return {
                        index: String(index + 1).padStart(2, '0'),
                        date: companyDateFormat(voucher?.date) || '',
                        receiptVoucherNo: voucher.receiptVoucherNo || '',
                        shipmentId: voucher.shipmentId || '',
                        customerName: voucher?.customer?.clientCompanyName || '',
                        amount: formattedAmount,
                        particulars: voucher.particulars || []
                    };
                });

                setData(receiptData);
                setRowCount(response.data.pagination?.totalRecords || 0);

            } else {
                setError("No receipt vouchers found.");
            }
        } catch (err) {
            console.error("Fetch error:", err);
            setError("Error fetching receipt vouchers.");
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        fetchData(page, pageSize)
    }, [page, pageSize, token])


    const enableExpanding = true;
    const getRowCanExpand = () => true;

    const renderDetailPanel = ({ row }) => {
        const particulars = row.original?.particulars || [];

        return (
            <Box sx={{ background: "#f9f9f9", p: 0 }}>
                <Box sx={{
                    display: 'flex',
                    fontWeight: '600',
                    mb: 1,
                    borderBottom: '1px solid #ccc',
                    paddingBottom: '5px',
                    fontSize: '14px'
                }}>
                    <Box sx={{ width: '100px', textAlign: 'center' }}>Date</Box>
                    <Box sx={{ width: '160px', textAlign: 'center' }}>PI No</Box>
                    <Box sx={{ width: '160px', textAlign: 'center' }}>CI No</Box>
                    <Box sx={{ width: '150px', textAlign: 'center' }}>Payment Name</Box>
                    <Box sx={{ width: '120px', textAlign: 'center' }}>Amount</Box>
                </Box>

                {particulars.length > 0 ? particulars.map((item, idx) => (
                    <Box key={idx} sx={{ display: 'flex', fontSize: '13px', borderBottom: '1px dashed #ddd', py: 0.5 }}>
                        <Box sx={{ width: '100px', textAlign: 'center' }}>{companyDateFormat(item.date || '-')}</Box>
                        <Box sx={{ width: '160px', textAlign: 'center' }}>
                            {item.importPiNoList?.proformaInvoiceNo || item.exportPiNoList?.proformaInvoiceNo || '-'}
                        </Box>
                        <Box sx={{ width: '160px', textAlign: 'center' }}>
                            {item.importCiNoList?.commercialInvoiceNo || item.exportCiNoList?.commercialInvoiceNo || '-'}
                        </Box>
                        <Box sx={{ width: '150px', textAlign: 'center' }}>
                            {item.receiptType?.receiptTypeName || '-'}
                        </Box>
                        <Box sx={{ width: '120px', textAlign: 'center' }}>
                            {`${item.currency?.currency_symbol || ''} ${parseFloat(item.referenceAmount || 0).toFixed(2)}`}
                        </Box>
                    </Box>
                )) : (
                    <Box sx={{ textAlign: 'center', color: '#888', fontStyle: 'italic' }}>
                        No sub-row data available
                    </Box>
                )}
            </Box>
        );
    };


    const defaultView = 'receiptregister';
    const mainContent = (
        <>
            <CustomDataTable
                title={title}
                columns={columns}
                data={data}
                enableExpanding={enableExpanding}
                getRowCanExpand={getRowCanExpand}
                renderDetailPanel={renderDetailPanel}
                handleFilterButton={filterOpen}
                fiterButtonTitile="Fiter"
                rowCount={rowCount}
                page={page}
                setPage={setPage}
                pageSize={pageSize}
                setPageSize={setPageSize}
                fromDate={filterPayload.fromDate || ""}
                toDate={filterPayload.toDate || ""}

            />
            <CustomFilter
                drawerTitle="Filter Options"
                drawerWidth={300}
                openDrawer={openDrawer}
                onClose={filterClose}
                drawerContent={
                    <>
                        <Box>
                            <Grid container spacing={1} sx={{ padding: 0, }}>
                                <Grid item xs={12} sm={12} md={12}>
                                    <CustomTextField
                                        type="text"
                                        placeholder="Enter Shipment ID"
                                        value={filterPayload.shipmentId}
                                        onChange={(e) => handleFilterChange('shipmentId', e.target.value)}

                                    />
                                </Grid>
                                <Grid item xs={12} sm={12} md={12}>
                                    <CustomAutocomplete
                                        options={custumersList}
                                        getOptionLabel={(option) => option.title}
                                        placeholder="Select Customer"
                                        value={custumersList.find((item) => item.id === filterPayload.customerName) || null}
                                        onChange={(event, newValue) => handleFilterChange("customerName", newValue?.id)}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={12} md={12}>
                                    <CustomTextField
                                        fieldLabel="from Date"
                                        type="date"
                                        value={filterPayload.fromDate}
                                        onChange={(e) => handleFilterChange('fromDate', e.target.value)}
                                        placeholder="From Date"
                                    />
                                </Grid>
                                <Grid item xs={12} sm={12} md={12}>
                                    <CustomTextField
                                        fieldLabel="to Date"
                                        type="date"
                                        value={filterPayload.toDate}
                                        onChange={(e) => handleFilterChange('toDate', e.target.value)}
                                        placeholder="To Date"
                                    />
                                </Grid>

                                <Grid item xs={12} sm={12} md={12} sx={{ display: 'flex', alignItems: 'center', marginTop: "10px" }}>
                                    <CustomButton
                                        startIcon={<FindReplaceOutlinedIcon />}
                                        title="Apply"
                                        size="small"
                                        variant="contained"
                                        onClick={fetchData}
                                    />
                                    <CustomButton
                                        variant="outlined"
                                        title="Clear"
                                        startIcon={<ClearRounded />}
                                        onClick={handleClearFilters}
                                    />
                                </Grid>
                            </Grid>
                        </Box>
                    </>
                }
            />
        </>
    );

    const getMainContent = (mainContent, permission) => {
        return permission?.view ? mainContent : null;
    };
    return (
        <>
            <CustomReport
                defaultView={defaultView}
                mainContent={getMainContent(mainContent, permission)} />
            {!permission?.view && <AccessDenied />}
        </>

    );
};
export default Function;
